<ul class="navigation-list" #navigation>
  @for (item of items; track $index; let index = $index) {
    <li class="navigation-list-item" [class.active]="activeIndex === index" (click)="indexChange.emit(index)">
      <div class="navigation-dot-item"></div>
    </li>
  }
</ul>
